<template>
    <div id="pre-black-wrapper">
        <picture>
            <source :srcset="bannerPrincipal.mobile" media="(max-width: 767px)" />
            <img :src="bannerPrincipal.desktop" class="img-responsive" />
        </picture>
        <div class="content d-flex flex-column flex-justify-center flex-align-center">
            <h1>Black Friday Chico Rei 2024: Camisetas em promoção</h1>
            <p>
                A <strong>Black Friday 2024</strong> será
                <strong>a maior de toda a história da Chico Rei.</strong>
                Serão camisetas, roupas masculinas, femininas, infantis e acessórios com
                <strong>descontos incríveis!</strong>
            </p>
            <p>
                E ainda terá <strong>CASHBACK ESPECIAL</strong> para você poder
                <strong>usar a vontade em suas compras!</strong>
            </p>

            <p>
                Enquanto o dia <strong>29 de novembro</strong> não chega, veja abaixo tudo que você
                encontrará em nossa Black Friday e
                <strong>formas de receber descontos exclusivos!</strong>
            </p>

            <h2>Inscreva-se na nossa Newsletter e receba promoções e descontos exclusivos!</h2>
        </div>
        <PreBlackBanner :data="banner" />
        <PreBlackContent />
        <PreBlackProductList />
    </div>
</template>

<script>
    import PreBlackBanner from './content/PreBlackBanner.vue';
    import PreBlackContent from './content/PreBlackContent.vue';
    import PreBlackProductList from './content/PreBlackProductList.vue';
    import { resizeOrientationAware } from '../../../common/common';
    import { scrollToPosition } from '../../../common/common';

    export default {
        name: 'PreBlackFriday',
        el: '#pre-black-friday-vue',

        components: {
            PreBlackBanner,
            PreBlackContent,
            PreBlackProductList,
        },

        mounted() {
            scrollToPosition(0, 0);
        },

        data() {
            return {
                banner: {
                    desktop:
                        this.$scope.CDN_IMAGES +
                        '/images/hotsites/blackfriday-2024/BF_Banner_superior_LandingPage_PreBF_desktop_171024_02.png',
                    mobile:
                        this.$scope.CDN_IMAGES +
                        '/images/hotsites/blackfriday-2024/BF_Banner_superior_LandingPage_PreBF_mobile_171024_02.png',
                },

                bannerPrincipal: {
                    desktop:
                        this.$scope.CDN_IMAGES +
                        '/images/hotsites/blackfriday-2024/BF_Banner_superior_LandingPage_PreBF.png',
                    mobile:
                        this.$scope.CDN_IMAGES +
                        '/images/hotsites/blackfriday-2024/BF_Banner_superior_LandingPage_PreBF_mobile_V3.png',
                },
            };
        },
    };
</script>
